export default __webpack_public_path__ + "static/klabbet-grue-86d436e7c3d62a98ec48fd37dab4ec7a.png";